import { object, ref, string } from 'yup';

const AdminChangePasswordSchema = object().shape({
  oldPassword: string('').required('Please enter your current password'),
  newPassword: string('').required('Enter your password').min(6, 'Password must contain at least 6 characters'),
  confirmNewPassword: string()
    .required('Please confirm your password')
    .oneOf([ref('newPassword')], 'Passwords does not match'),
});

export default AdminChangePasswordSchema;
